import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
//@ts-ignore
import LKModal, { LKModalContainer, actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import withLookups, { LookupType } from 'shared/containers/withLookups'
//@ts-ignore
import { destroy } from 'shared/LKGrid'
//@ts-ignore
import { LocalSearchGrid } from 'shared/Helpers'
//@ts-ignore
import LKButton from 'shared/LKButton'

import { addLoanPermissionsModalName, addPermissionFetcherName } from '../../constants'
import { translatePermissions, translateBase } from '../../helpers'

import { AddLoanPermissionsModalProps, Lookup } from '../../types.LoanDetails'
import { addPermission, addPermissionLoading } from 'src/store/loan'
import { AppDispatch } from 'src/store/index.d'

const config = {
  instanceName: 'LoanPermissionAdd',

  gridIdentity: {
    formName: 'frm_sec_RL_add_edit',
    objectName: 'dbgrd_users',
  },

  columnDefs: [
    { headerName: 'Active', field: 'Active' },
    { headerName: 'LoginFull', field: 'LoginFull' },
    { headerName: 'GroupName', field: 'GroupName' },
  ],

  enableColumnsResize: true,
  enableRowSelection: true,
  selectFirstRow: true,

  columnConfigs: {
    Active: {
      iconComponent: (value: number) => (value === 1 ? 'ok' : 'cancel'),
    },
  },
}

@LKModalContainer(addLoanPermissionsModalName)
@withLookups({ type: LookupType.Users })
@withRouter
//@ts-ignore
@connect(
  // (state) => ({ loading: getPending(addPermissionFetcherName)(state) }),
  (state) => ({ loading: addPermissionLoading(state) }),
  (
    dispatch: AppDispatch,
    {
      //@ts-ignore
      match: {
        params: { ID, hash },
      },
      //@ts-ignore
      onRefresh,
    },
  ) => ({
    addPermission: (permissionID: number) => {
      // dispatch(
      //   fetchSFM({
      //     instanceName: addPermissionFetcherName,
      //     callApi: Loan.addPermission,
      //     callApiArgs: [permissionID, ID, hash],
      //     resolve: () => {
      //       dispatch(LKModalActions.close(addLoanPermissionsModalName))
      //       dispatch(destroy(addLoanPermissionsModalName))

      //       onRefresh()
      //     },
      //     reject: (error: { Error: { Message: string; Text: string } }) => {
      //       dispatch(LKModalActions.openInfo(translateBase(error.Error.Message || error.Error.Text)))
      //     },
      //   }),
      // )

      //UPDATED API REQUEST loan_oper_api page:accesspermadd
      dispatch(
        addPermission({
          LoanID: ID,
          HashSum_LoanID_: hash,
          ID: permissionID,
        }),
      ).then((response) => {
        if (!addPermission.fulfilled.match(response)) {
          dispatch(LKModalActions.openInfo(translateBase(response.payload as string)))
          return
        }
        dispatch(LKModalActions.close(addLoanPermissionsModalName))
        dispatch(destroy(addLoanPermissionsModalName))
        onRefresh()
      })
    },
  }),
)
class AddLoanPermissionsModal extends React.PureComponent<AddLoanPermissionsModalProps> {
  state: {
    permissionID?: number
    filtered: Lookup[]
  } = {
    permissionID: undefined,
    filtered: [],
  }

  componentDidMount() {
    this.handleModalOpen()
  }

  handleModalOpen = () => {
    const filtered = this.props.lookups.filter(
      (permission) =>
        permission.Active !== 0 &&
        permission.ID > 0 &&
        !this.props.addedPermissions.find((addedPermission) => addedPermission.SEC_UserID === permission.ID),
    )

    this.setState({ filtered })
  }

  handleInputChange = (filtered: Lookup[]) => {
    if (!filtered.length) {
      this.setState({ permissionID: undefined })
    }
  }

  handleRowSelection = (gridRow) => {
    const {
      node: {
        data: { ID },
        selected,
      },
    } = gridRow

    if (selected) {
      this.setState({ permissionID: ID })
    }
  }

  handleSubmit = () => {
    this.props.addPermission(this.state.permissionID)
  }

  render() {
    const { modalInstanceName, lookups, loading } = this.props
    const { filtered } = this.state

    return (
      <LKModal
        name={modalInstanceName}
        heading={translatePermissions('frm_sec_RL_add_edit')}
        loading={!lookups}
        size="sm-1"
        footer={
          <LKModal.Footer>
            <LKButton alias="add" onClick={this.handleSubmit} loading={loading} disabled={loading}>
              {translatePermissions('cmd_finish')}
            </LKButton>
          </LKModal.Footer>
        }
      >
        <LocalSearchGrid
          data={filtered}
          LKGridConfig={config}
          onRowSelected={this.handleRowSelection}
          searchBy="LoginFull"
          onInputChange={this.handleInputChange}
        />
      </LKModal>
    )
  }
}

export const openAddLoanPermissionsModal = (data?: any) =>
  LKModalActions.open({ name: addLoanPermissionsModalName, data })

export default AddLoanPermissionsModal
